import { useState } from "react"
import { Modal, Typography, Tabs } from "antd"
import { UnorderedListOutlined, HistoryOutlined } from "@ant-design/icons"
import { ListaSoportes } from "./ListaSoportes"
import { FormularioReemplazo } from "./FormularioReemplazo"
import { HistoricoReemplazos } from "./HistoricoReemplazos"

const { Title } = Typography

export function ModalSoporteReemplazo({ open, onOpenChange, limpiar, remplazo_ruta, selectItemRemplazo, onUploaded }) {
  const [mostrarFormulario, setMostrarFormulario] = useState(false)
  const [refreshTrigger, setRefreshTrigger] = useState(0)
  const [tabActiva, setTabActiva] = useState("lista")

  const handleCrearReemplazo = () => {
    setMostrarFormulario(true)
  }

  const handleFormularioSuccess = () => {
    setMostrarFormulario(false)
    setRefreshTrigger(prev => prev + 1)
  }

  const handleFormularioCancel = () => {
    setMostrarFormulario(false)
  }

  const handleModalClose = () => {
    setMostrarFormulario(false)
    setTabActiva("lista")
    onOpenChange(false)
  }

  const handleTabChange = (key) => {
    setTabActiva(key)
    setMostrarFormulario(false)
  }

  const tabItems = [
    {
      key: "lista",
      label: (
        <span>
          <UnorderedListOutlined /> Lista actual
        </span>
      ),
      children: mostrarFormulario ? (
        <FormularioReemplazo
          onSuccess={handleFormularioSuccess}
          onCancel={handleFormularioCancel}
          remplazo_ruta={remplazo_ruta}
        />
      ) : (
        <ListaSoportes
          onCrearReemplazo={handleCrearReemplazo}
          refreshTrigger={refreshTrigger}
          limpiar={limpiar}
          selectItemRemplazo={selectItemRemplazo}
          onUploaded={onUploaded}
        />
      ),
    },
    {
      key: "historico",
      label: (
        <span>
          <HistoryOutlined /> Histórico
        </span>
      ),
      children: <HistoricoReemplazos codUnicoFiltro={undefined} />,
    },
  ]

  return (
    <Modal
      open={open}
      destroyOnHidden
      onCancel={handleModalClose}
      footer={null}
      width="90%"
      style={{ top: 20 }}
      styles={{ body: { maxHeight: "80vh", overflowY: "auto" } }}
      title={<Title level={3}>Sistema de Reemplazo de Soportes</Title>}
    >
      <Tabs
        activeKey={tabActiva}
        onChange={handleTabChange}
        items={tabItems}
      />
    </Modal>
  )
}